export default "__VITE_ASSET__729513c8__"